import { lazy } from "react"
import { ACL_READ, ACL_SUBJECT_REPORT_PERSON, ACL_SUBJECT_REPORT_ORGANIZATION } from "@configs/acl/constants"

const ReportRoutes = [
  {
    path: "/report/persons",
    component: lazy(() => import("@views/report/persons")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_REPORT_PERSON
    }
  },
  {
    path: "/report/organizations",
    component: lazy(() => import("@views/report/organizations")),
    exact: true,
    meta: {
      action: ACL_READ,
      resource: ACL_SUBJECT_REPORT_ORGANIZATION
    }
  }
]

export default ReportRoutes
